<template>
  <div>
    <div v-if="this.$store.state.customModule.industry" class="subject">
      <img class="content" src="http://hpc.devotedigital.cn/resources/img/total.png">
      <img class="close" src="http://hpc.devotedigital.cn/resources/img/close.png" @click="IndustryShowClick">
      <!-- 轮播区域图片 -->
      <img
        v-if="this.$store.state.customModule.industryImgShow!=='rightHide'"
        class="imgLeft"
        src="http://hpc.devotedigital.cn/resources/img/nextlevel.png"
        @click="toLeft"
      >
      <div class="rotation">
        <div
          v-for="item in imgUrlData"
          ref="img"
          :key="item.index"
          :class="item.class"
        >
          <img :src="item.img" @click="showIndustry(item.action)">
          <span>
            {{ item.text }}
          </span>
        </div>
      </div>
      <img
        v-if="this.$store.state.customModule.industryImgShow!=='leftHide'"
        class="imgRight"
        src="http://hpc.devotedigital.cn/resources/img/lowerlevel.png"
        @click="toRight"
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgUrlData: []
    }
  },
  mounted() {
    const json = require('@media/rotationImg.json')
    this.imgUrlData = json.imgUrl
    this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
  },
  methods: {
    IndustryShowClick() {
      this.$store.commit('customModule/setIndustry', false)
      this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      this.$emit('divClose')
    },
    toLeft() {
      var index
      // console.log(this.$refs.img[0].className)
      for (var i = 0; i < this.$refs.img.length; i++) {
        if (this.$refs.img[i].className === 'left3') {
          index = i
        }
      }
      this.$refs.img[index].className = 'left4'
      this.imgUrlData[index].class = 'left4'
      this.$refs.img[index - 1].className = 'left3'
      this.imgUrlData[index - 1].class = 'left3'
      this.$refs.img[index - 2].className = 'left2'
      this.imgUrlData[index - 2].class = 'left2'
      this.$refs.img[index - 3].className = 'left1'
      this.imgUrlData[index - 3].class = 'left1'
      this.$refs.img[index - 4].className = 'left0'
      this.imgUrlData[index - 4].class = 'left0'
      if (this.$refs.img[0].className === 'left0') {
        this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      } else if (
        this.$refs.img[this.$refs.img.length - 1].className === 'left3'
      ) {
        this.$store.commit('customModule/setIndustryImgShow', 'leftHide')
      } else {
        this.$store.commit('customModule/setIndustryImgShow', 'notHide')
      }
      const imgFrist = this.$refs.img[0].className
      const imgLast = this.$refs.img[this.$refs.img.length - 1].className
      this.$store.commit('customModule/setImgArray', [imgFrist, imgLast])
    },
    toRight() {
      var index
      // console.log(this.$refs.img[0].className)
      for (var i = 0; i < this.$refs.img.length; i++) {
        if (this.$refs.img[i].className === 'left0') {
          index = i
        }
      }
      // console.log(this.imgUrlData)
      this.$refs.img[index].className = 'left-1'
      this.imgUrlData[index].class = 'left-1'
      this.$refs.img[index + 1].className = 'left0'
      this.imgUrlData[index + 1].class = 'left0'
      this.$refs.img[index + 2].className = 'left1'
      this.imgUrlData[index + 2].class = 'left1'
      this.$refs.img[index + 3].className = 'left2'
      this.imgUrlData[index + 3].class = 'left2'
      this.$refs.img[index + 4].className = 'left3'
      this.imgUrlData[index + 4].class = 'left3'
      if (this.$refs.img[0].className === 'left0') {
        this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      } else if (
        this.$refs.img[this.$refs.img.length - 1].className === 'left3'
      ) {
        this.$store.commit('customModule/setIndustryImgShow', 'leftHide')
      } else {
        this.$store.commit('customModule/setIndustryImgShow', 'notHide')
      }
      const imgFrist = this.$refs.img[0].className
      const imgLast = this.$refs.img[this.$refs.img.length - 1].className
      this.$store.commit('customModule/setImgArray', [imgFrist, imgLast])
    },
    showIndustry(action) {
      // console.log(action)
      this.$store.commit('customModule/setIndOverall', true)
      this.$store.commit('customModule/setIndustry', false)
      const imgFrist = this.$refs.img[0].className
      const imgLast = this.$refs.img[this.$refs.img.length - 1].className
      this.$store.commit('customModule/setImgArray', [imgFrist, imgLast])
      // console.log(this.$store.state.customModule.imgArray)
      this.$emit('chanageImg', 'http://hpc.devotedigital.cn/resources/img/industry.png')
      switch (action.type) {
        case 'img':
          this.$store.commit('customModule/setIndOverallImg', action.url[0])
          this.$store.commit('customModule/setIndOverallArray', action.url)
          this.$store.commit('customModule/setIsImgOrVideo', 'img')
          this.$store.commit('customModule/setIndOverallDivText', action.text)
          if (action.name === 'onlyOneData') {
            this.$store.commit('customModule/setIndOverallBtnShow', 'allHide')
          } else {
            this.$store.commit('customModule/setIndOverallBtnShow', 'leftHide')
          }
          break
        case 'video':
          this.$store.commit('customModule/setIndOverallImg', action.video[0])
          this.$store.commit('customModule/setIndOverallArray', action.video)
          this.$store.commit('customModule/setIsImgOrVideo', 'video')
          this.$store.commit('customModule/setIndOverallDivText', action.text)
          if (action.name === 'onlyOneData') {
            this.$store.commit('customModule/setIndOverallBtnShow', 'allHide')
          } else {
            this.$store.commit('customModule/setIndOverallBtnShow', 'leftHide')
          }
          break
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.subject {
  position: absolute;
  width: 60vw;
  height: 32vw;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -40%);
  // background-color: beige;
}
.content {
  width: 60vw;
  height: 32vw;
}
.close {
  position: absolute;
  left: 59vw;
  top:2vw;
  width: 60px;
  height: 60px;
  cursor: pointer;
}
.imgLeft {
  cursor: pointer;
  position: absolute;
  left: 1vw;
  top: 50%;
  width: 6%;
  transform: translate(0, -50%);
}
.rotation {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 48vw;
  height: 14vw;
  // background-color: black;
  transform: translate(-50%, -50%);
  overflow: hidden;
  div {
    position: absolute;
    display: block;
    height: 14vw;
    width: 12vw;
    transition: all 1s ease;
    background-image: url("http://hpc.devotedigital.cn/resources/img/outer.png");
    background-size: 100% 100%;
    img {
      cursor: pointer;
      display: block;
      width: 260px;
      height: 146px;
      margin-left: 20px;
      margin-top: 72px;
    }
    span{
      position: absolute;
      color: white;
      left: 60px;
      bottom:90px;
      font-size: 20px;
    }
  }
  .left-1 {
    left: -300px;
  }
  .left0 {
    left: 0;
  }
  .left1 {
    left: 300px;
  }
  .left2 {
    left: 600px;
  }
  .left3 {
    left: 900px;
  }
  .left4 {
    transition: all 1s ease;
    left: 1200px;
  }
}
.imgRight {
  cursor: pointer;
  position: absolute;
  right: 1vw;
  top: 50%;
  width: 6%;
  transform: translate(0, -50%);
}
</style>
